import {IProduct} from 'data/interfaces/products';
import {ASSET_TYPE} from 'data/enums/assets';

export const generateAssetList = (product: IProduct): any => {
  if (Array.isArray(product.assets)) {
    return product.assets
      .filter(({type}) => type === ASSET_TYPE.PLACE);
  } else if (Array.isArray(product.hotelDetails.imagePick)) {
    return product.hotelDetails.imagePick
      .map((sourceLink) => ({asset: {sourceLink}}));
  }
  return [];
};

